import { render, staticRenderFns } from "./CheckoutFallbackVerify.vue?vue&type=template&id=06df4431&scoped=true"
import script from "./CheckoutFallbackVerify.vue?vue&type=script&lang=js"
export * from "./CheckoutFallbackVerify.vue?vue&type=script&lang=js"
import style0 from "./CheckoutFallbackVerify.vue?vue&type=style&index=0&id=06df4431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df4431",
  null
  
)

export default component.exports